/* Findings in the October 15, 2026 PowerMapper report only. */
(function () {
  'use strict';

  var path = window.location.pathname.replace(/\/$/, '');
  var ratingProducts = [
    '3m-8511-n95-particulate-respirator',
    'accu-pour-polypropylene-measuring-pitcher',
    'carhartt-0j392-m-washed-duck-sherpa-lined-jacket',
    'carhartt-a18-watch-cap',
    'dp-industries-bulk-hardwood-field-and-plant-labels',
    'dramm-colorstorm-professional-rubber-hose',
    'dupont-tyvek-hooded-coveralls-with-elastic-wrists-and-ankles',
    'gemplers-15-mil-unlined-nitrile-gloves-box-of-36',
    'gemplers-24-tine-spring-brace-lawn-leaf-rake-fiberglass-handle',
    'gemplers-4-mil-disposable-nitrile-gloves-box-of-100',
    'gemplers-8-mil-disposable-nitrile-gloves-bag-of-250',
    'gemplers-ever-lite-safety-glasses',
    'gemplers-extra-long-long-handled-tool-rack',
    'gemplers-extra-wide-long-handled-tool-rack',
    'gemplers-insulated-waterproof-pigskin-gloves-with-knit-wrist',
    'gemplers-pvc-on-nylon-rain-jacket-and-pants',
    'gemplers-rain-jacket-and-bibs-pvc-on-nylon',
    'gemplers-reacher-pickup-tool',
    'gemplers-steel-rake-hoe-with-wood-handle',
    'gopherhawk-mole-and-gopher-trap-with-wedge-and-probe-tool'
  ];
  var patchRatings = ratingProducts.some(function (handle) {
    return path === '/products/' + handle || path.endsWith('/products/' + handle);
  });
  var banner = path === '/collections/shovels' ? {
    filename: '/hi-vis-inline-banner.jpg',
    alt: 'Shop Hi-Vis Shirts, Jackets, Vests, and more!',
    width: 354, height: 704
  } : path === '/collections/workwear' ? {
    filename: '/new-arrivals-inline-banner.jpg',
    alt: 'Shop New Items: tools, supplies, safety, & workwear',
    width: 354, height: 704
  } : null;
  var scheduled = false;
  var offerContrast = path === '/pages/offers';
  var backgrounds = new WeakMap();

  function backgroundSource(card) {
    var match = window.getComputedStyle(card).backgroundImage.match(/url\(["']?(.*?)["']?\)/);
    return match ? match[1] : '';
  }

  function patchOfferContrast() {
    if (!offerContrast) return;
    document.querySelectorAll('[data-pm-contrast-original]').forEach(function (card) {
      var source = backgroundSource(card);
      var previous = backgrounds.get(card);
      if (previous && previous.source === source) return;
      // A dark gold passes against the light fallback. The original gold is
      // needed against the dark photograph, whose pixels were checked in QA.
      card.style.setProperty('--gp-card-cta-color', '#b28501');
      var cta = card.querySelector('.gemplers-2026-cta-trio__card-cta');
      if (cta) cta.style.opacity = '1';
      var state = {source: source};
      backgrounds.set(card, state);
      if (!source) return;
      var image = new Image();
      image.onload = function () {
        if (!image.naturalWidth || backgrounds.get(card) !== state || backgroundSource(card) !== source) return;
        card.style.setProperty('--gp-card-cta-color', card.getAttribute('data-pm-contrast-original'));
        if (cta) cta.style.removeProperty('opacity');
      };
      image.src = source;
    });
  }

  function patchAppMarkup() {
    scheduled = false;
    if (patchRatings) {
      document.querySelectorAll('.junip-product-summary-star-ratings-container[aria-label]').forEach(function (rating) {
        var role = rating.getAttribute('role');
        if (!role || role === 'generic') rating.setAttribute('role', 'img');
      });
    }
    if (banner) {
      document.querySelectorAll('img').forEach(function (image) {
        if (image.alt !== banner.alt || (image.getAttribute('src') || '').indexOf(banner.filename) < 0) return;
        if (!image.hasAttribute('width')) image.setAttribute('width', String(banner.width));
        if (!image.hasAttribute('height')) image.setAttribute('height', String(banner.height));
        // Keep the existing 100% responsive width and natural aspect ratio.
        if (!image.style.height) image.style.height = 'auto';
      });
    }
    patchOfferContrast();
    describePicker();
  }

  function schedulePatches() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(patchAppMarkup);
  }

  var productSelect;
  var activation = null;
  var enterPressed = false;
  var navigating = false;

  function pickerFor(target) {
    if (!productSelect || !target || !target.closest) return false;
    if (target === productSelect) return true;
    var wrapper = target.closest('.bootstrap-select');
    if (wrapper && wrapper.contains(productSelect)) return true;
    // Bootstrap-select portals its menu to body on desktop.
    var menu = target.closest('.dropdown-menu');
    while (menu && window.jQuery) {
      var instance = window.jQuery(menu).data('this');
      if (instance && instance.$element && instance.$element[0] === productSelect) return true;
      menu = menu.parentElement && menu.parentElement.closest('.dropdown-menu');
    }
    return false;
  }

  function describePicker() {
    if (!productSelect) return;
    var wrapper = productSelect.closest('.bootstrap-select');
    var button = wrapper && wrapper.querySelector('button.dropdown-toggle');
    if (button && button.getAttribute('aria-describedby') !== 'crossmenu-instructions') {
      button.setAttribute('aria-describedby', 'crossmenu-instructions');
    }
  }

  function openSelectedProduct() {
    if (!productSelect || !productSelect.value || navigating) return;
    var destination;
    try { destination = new URL(productSelect.value, window.location.href); } catch (error) { return; }
    // The existing options are same-store product links.
    if (destination.origin !== window.location.origin || !/^\/products\//.test(destination.pathname)) return;
    navigating = true;
    window.location.assign(destination.href);
  }

  function initProductNavigation() {
    productSelect = document.querySelector('#crossmenu[data-pm-product-navigation]');
    if (!productSelect) return;

    document.addEventListener('pointerdown', function (event) {
      activation = pickerFor(event.target) ? 'pointer' : null;
      enterPressed = false;
    }, true);
    document.addEventListener('keydown', function (event) {
      if (!pickerFor(event.target)) return;
      activation = 'keyboard';
      enterPressed = event.key === 'Enter' && !event.repeat;
      if (enterPressed && event.target === productSelect) {
        event.preventDefault();
        openSelectedProduct();
      }
      if (event.key === 'Escape') {
        productSelect.value = '';
        if (window.jQuery && window.jQuery(productSelect).data('selectpicker')) {
          window.jQuery(productSelect).selectpicker('render');
        }
      }
    }, true);
    document.addEventListener('keyup', function (event) {
      if (!pickerFor(event.target)) return;
      if (event.key === 'Enter' && enterPressed) openSelectedProduct();
      enterPressed = false;
    }, true);
    productSelect.addEventListener('change', function () {
      // Arrow-key/typeahead changes never navigate. Enter commits keyboard
      // choices; pointer selection preserves the existing click/touch behavior.
      if (activation === 'pointer' || enterPressed) openSelectedProduct();
    });
    if (window.jQuery) {
      window.jQuery(productSelect).on('loaded.bs.select.pmScan refreshed.bs.select.pmScan', describePicker);
    }
    describePicker();
  }

  function init() {
    initProductNavigation();
    if (offerContrast) window.addEventListener('resize', schedulePatches, {passive: true});
    patchAppMarkup();
    if (patchRatings || banner || productSelect || offerContrast) {
      new MutationObserver(schedulePatches).observe(document.documentElement, {
        subtree: true, childList: true, attributes: true,
        attributeFilter: ['role', 'aria-label', 'src']
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
